/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdminListJoinedMoneyPoolsRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {AdminListJoinedMoneyPoolsResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const adminListJoinedMoneyPools = (request: AdminListJoinedMoneyPoolsRequest, options?: CashRequestOptions) => post<AdminListJoinedMoneyPoolsRequest, AdminListJoinedMoneyPoolsResponse>("/2.0/cash/admin-list-joined-money-pools", request, {...options, rejectOnError: true })